/**
 * "Report a problem or suggest a change" for this panel (Bill 2026-10-07: the
 * three panels get the same tool as the Teams app). The lifebuoy, dialog,
 * background log capture and screen picture are the shared
 * @retail-ops/support-report package; reports post to the existing
 * POST /v3/events (eventType support.report) and reach the same people,
 * suggestions routed to management first.
 */
import { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router';
import { SupportReportButton, type SupportEventWrite } from '@retail-ops/support-report';
import { useAuth } from '@/contexts/AuthContext';
import { useApiClient } from '@/contexts/ApiClientContext';
import { APP_NAME, APP_VERSION, APP_BUILD_TIME } from '@/constants/version';

export function PanelSupportReport(): JSX.Element {
  const { user } = useAuth();
  const client = useApiClient();
  const loc = useLocation();

  const reporter = useMemo(() => user ? {
    upn: user.upn,
    displayName: user.displayName,
    role: user.roles.join(', ') || null,
  } : null, [user]);

  const submit = useCallback((event: SupportEventWrite) => client.retail.events.write(event), [client]);

  return (
    <SupportReportButton
      appName={APP_NAME}
      appVersion={APP_VERSION}
      appBuild={APP_BUILD_TIME}
      reporter={reporter}
      page={loc.pathname + loc.search}
      submit={submit}
    />
  );
}

export default PanelSupportReport;
